/**
 * The shell's own catalogue.
 *
 * `src/i18n/pt-BR.ts` is the global catalogue and already holds the chrome
 * strings that were known when it was written (`shell.appName`,
 * `shell.loading`, `common.retry`); those are used from `t` directly and are
 * not restated here. The strings below are the ones the shell introduces,
 * and they go through `defineCatalogue` for the same reason
 * every feature area's do: a key set that lives in a file more than one plan
 * has to edit is a collision, and the per-area catalogue is this project's
 * answer to it. `defineCatalogue` reads the active locale on every call, so
 * `setLocale()` re-points this catalogue and the global one in the same
 * instant.
 */

import { defineCatalogue } from '../../i18n';

export const shellCatalogue = defineCatalogue(
  {
    'nav.label': 'Navegação principal',
    'nav.skip': 'Ir direto ao conteúdo',

    'forbidden.title': 'Sem permissão',
    'forbidden.body':
      'Esta conta não tem o direito necessário para esta página. Quem administra a ' +
      'organização pode conceder o acesso.',

    'session.error.title': 'Não foi possível confirmar os seus direitos de acesso.',
    'session.error.body':
      'Enquanto seus direitos de acesso não são confirmados, nada é liberado. Tente novamente.',

    'home.noOrganisation.title': 'Sua conta está pronta',
    'home.noOrganisation.body':
      'Você ainda não tem acesso a uma organização, crie uma nova ou solicite um convite ao seu administrador.',
    'home.noOrganisation.createOrganisation': 'Criar organização',
    'home.noOrganisation.switchAccount': 'Entrar com outra conta',
  },
  {
    'nav.label': 'Main navigation',
    'nav.skip': 'Skip to content',

    'forbidden.title': 'Not permitted',
    'forbidden.body':
      'This account does not hold the grant this page needs. Whoever administers the ' +
      'organisation can grant it.',

    'session.error.title': 'Your access rights could not be confirmed.',
    'session.error.body': 'Until your access rights are confirmed, nothing is released. Try again.',

    'home.noOrganisation.title': 'Your account is ready',
    'home.noOrganisation.body':
      "You don't have access to an organisation yet. Create a new one or ask your administrator for an invite.",
    'home.noOrganisation.createOrganisation': 'Create organisation',
    'home.noOrganisation.switchAccount': 'Sign in with another account',
  },
);

/** `ts` rather than `t`: the global `t` from `src/i18n` is imported alongside
 *  it in several of these files, and two identically named functions resolving
 *  different key sets is a trap. */
export const ts = shellCatalogue.t;
